

export const LibraryIcon = (props) => {

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
           <g fill="none" fillRule="evenodd">
        <g>
            <g>
                <g>
                    <path d="M0 0L24 0 24 24 0 24z" transform="translate(-1264 -961) translate(406 961) translate(858)"/>
                    <path fill={props.isActive? '#3ac0a2':'#2e2744'} fillOpacity="1" fillRule="nonzero" d="M21 4H7c-1.105 0-2 .895-2 2s.895 2 2 2h14v13c0 .552-.448 1-1 1H7c-2.21 0-4-1.79-4-4V6c0-2.21 1.79-4 4-4h13c.552 0 1 .448 1 1v1zm-1 3H7c-.552 0-1-.448-1-1s.448-1 1-1h13v2z" transform="translate(-1264 -961) translate(406 961) translate(858)"/>
                </g>
            </g>
        </g>
    </g>
        </svg>
    )
}